<template>
	<div class="publicBox billBox">
		<div class="main">
			<ul class="titleList flexBox">
				<li>发票换开</li>
			</ul>
		</div>
		
		<InvoiceForm
			v-model="infoForm"
			:loading="loading"
			loading-text="换开中，请稍候..."
			tip-title="换开说明"
			tip-content="您好，请核对换开信息，金额不可修改，提交后不可修改。"
			submit-button-text="发票换开"
			:is-reissue="true"
			:original-amount="originalAmount"
			@submit="handleSubmit"
		/>
	</div>
</template>

<script>
import InvoiceForm from '../../../components/InvoiceForm.vue';

export default {
	name: 'BillReissue',
	components: {
		InvoiceForm
	},
	data() {
		return {
			loading: false,
			infoForm: {
				invoiceType: "增值税电子专用发票"
			},
			originalAmount: 0 // 原始金额，用于验证
		}
	},
	mounted() {
		this.getOriginalInvoiceData()
	},
	methods: {
		getOriginalInvoiceData() {
			const id = this.$route.params.id || this.$route.query.id;
			this.$reqToken("get", "/api/center/invoice/" + id, {}).then((res) => {
				if (res.data) {
					this.loadInvoiceData(res.data);
				} else {
					this.$router.push('/admin/bill');
				}
			});
		},
		// 加载发票数据的公共方法
		loadInvoiceData(originalData) {
			// 验证发票状态是否允许换开
			if (originalData.status != 1) {
				this.$message.error("该发票状态不允许换开");
				this.$router.push('/admin/bill');
				return;
			}
			// 保存原始金额，用于后续验证
			this.originalAmount = originalData.invoiceAmount || 0;
			// 预填充表单，但保持金额不变
			this.infoForm = {
				id: originalData.id,
				invoiceTitle: originalData.invoiceTitle || '',
				taxNumber: originalData.taxNumber || '',
				invoiceAmount: originalData.invoiceAmount || 0,
				invoiceType: originalData.invoiceType || '增值税电子专用发票',
				comPhone: originalData.comPhone || '',
				address: originalData.address || '',
				bankName: originalData.bankName || '',
				bankAccount: originalData.bankAccount || '',
				contactPerson: originalData.contactPerson || '',
				contactPhone: originalData.contactPhone || '',
				contactEmail: originalData.contactEmail || '',
				remark: originalData.remark || ''
			};
		},
		handleSubmit(formData) {
			this.loading = true;
			// 调用换开接口
			this.$reqToken("post", "/api/center/invoice/reissue", formData).then((res) => {
				if(res.code && res.code == 200) {
					this.$message.success(res.msg || "换开申请提交成功");
					this.$router.push('/admin/bill');
				} else {
					this.$message.error(res.msg || "换开申请提交失败");
				}
			}).catch((error) => {
				// 处理错误情况
				this.$message.error("换开申请提交失败，请重试");
				console.error("换开申请失败:", error);
			}).finally(() => {
				// 无论成功还是失败，都要关闭loading状态
				this.loading = false;
			})
		}
	}
}
</script>

<style scoped>
	@import url("../../../assets/css/admin/bill.css");
</style>